import React from 'react';

function OurClientsSection() {
  const styles = {
    section: {
      padding: '80px 48px 80px', background: '#fff'
    },
    subheadingRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 8
    },
    dashLine: {
      width: 150, height: 0, borderTop: '2px solid #E73123', flexShrink: 0
    },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textAlign: 'center', textTransform: 'uppercase',
      color: '#090909', margin: 0
    },
    titleWrap: { textAlign: 'center', marginBottom: 48 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase', color: '#E73123'
    },
    titleBlack: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase', color: '#090909'
    },
    logosGrid: {
      display: 'flex', flexDirection: 'column', gap: 60
    },
    logosRow: {
      display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 60
    },
    logoBlock: {
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
    }
  };

  var row1 = [
    { src: '/dinesh.jpg', alt: 'Dineshchandra R. Agrawal Infracon Pvt. Ltd.', w: 300, h: 108 },
    { src: '/kalpataru.png', alt: 'Kalpataru Projects International Limited', w: 300, h: 108 },
    { src: '/tata.jpg', alt: 'TATA PROJECTS LIMITED', w: 300, h: 108 }
  ];
  var row2 = [
    { src: '/urcc.png', alt: 'URC Building Values', w: 232, h: 108 },
    { src: '/keller.png', alt: 'Keller', w: 300, h: 108 },
    { src: '/kec.png', alt: 'KEC International Limited', w: 300, h: 108 }
  ];
  var row3 = [
    { src: '/afcons.png', alt: 'AFCONS', w: 268, h: 70 },
    { src: '/isgsec.png', alt: 'ISGEC Heavy Engineering Ltd.', w: 195, h: 108 }
  ];

  function renderRow(clients) {
    return React.createElement('div', { style: styles.logosRow, className: 'our-clients-logos-row' },
      clients.map(function (c, i) {
        return React.createElement('div', { key: i, style: styles.logoBlock, className: 'our-clients-logo-block' },
          React.createElement('img', {
            src: c.src,
            alt: c.alt,
            style: { width: c.w, height: c.h, objectFit: 'contain' }
          })
        );
      })
    );
  }

  return React.createElement('section', { style: styles.section, className: 'our-clients-section' },
    React.createElement('div', { style: styles.subheadingRow },
      React.createElement('div', { style: styles.dashLine }),
      React.createElement('h2', { style: styles.subheading }, 'OUR CLIENTS'),
      React.createElement('div', { style: styles.dashLine })
    ),
    React.createElement('div', { style: styles.titleWrap },
      React.createElement('div', null,
        React.createElement('span', { style: styles.titleRed }, 'EARNING TRUST '),
        React.createElement('span', { style: styles.titleBlack }, 'THROUGH PERFORMANCE'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'AND RELIABILITY')
      )
    ),
    React.createElement('div', { style: styles.logosGrid, className: 'our-clients-logos-grid' },
      renderRow(row1),
      renderRow(row2),
      renderRow(row3)
    )
  );
}

export default OurClientsSection;
